import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { BoardNameEntryProps } from "./types";

export const BoardNameEntry = ({
  initialName,
  submitLabelKey,
  onSubmit,
  onCancel,
}: BoardNameEntryProps) => {
  const { t } = useTranslation();
  const [name, setName] = useState(initialName);

  const trimmed = name.trim();

  const submit = () => {
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <div
      data-testid="karl-board-name"
      className="mt-2.5 flex items-center gap-1.5 rounded-lg border border-blue-300 bg-white p-2"
    >
      <input
        autoFocus
        value={name}
        onChange={(event) => setName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") submit();
          if (event.key === "Escape") onCancel();
        }}
        placeholder={t("smartSurveyor.cablesBeta.askBoardNamePlaceholder")}
        className="min-w-0 flex-1 rounded-md border border-slate-300 px-2.5 py-2 text-[15px] text-slate-800 outline-none focus:border-blue-500"
      />
      <button
        type="button"
        disabled={!trimmed}
        onClick={submit}
        className="rounded-md bg-blue-600 px-3 py-2 text-[14px] font-semibold text-white hover:opacity-90 disabled:opacity-40"
      >
        {t(`smartSurveyor.cablesBeta.${submitLabelKey}`)}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="rounded-md px-2.5 py-2 text-[14px] text-slate-600 hover:bg-slate-100"
      >
        {t("smartSurveyor.cablesBeta.cancel")}
      </button>
    </div>
  );
};
